import { useEffect } from "react";
import { useJourneyStore } from "../game/state/journeyMachine";

/**
 * Atajos de teclado globales del recorrido:
 *  - Flecha derecha / izquierda: etapa siguiente / anterior
 *  - H: ayuda · Esc: cerrar ayuda / volver
 */
export function useKeyboardNav(): void {
  const { nextStage, prevStage, helpOpen, setHelpOpen, screen, resetJourney } = useJourneyStore();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && ["INPUT", "SELECT", "TEXTAREA"].includes(target.tagName)) return;

      if (e.key === "ArrowRight") nextStage();
      else if (e.key === "ArrowLeft") prevStage();
      else if (e.key.toLowerCase() === "h") setHelpOpen(true);
      else if (e.key === "Escape") {
        if (helpOpen) setHelpOpen(false);
        else if (screen === "recorrido") resetJourney();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [nextStage, prevStage, helpOpen, setHelpOpen, screen, resetJourney]);
}
